import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/SupplierWallet`;


const ApiWallet = {

  getSupplierWalletByUserId: (params) => {
    // console.log("params==========",params);
    const url = `${baseServiceUrl}/getSupplierWalletByUserId`;
      console.log("url==========",url);
      return  ServiceApi.get(url );

  }, 

};

export default ApiWallet;


